export default __webpack_public_path__ + "static/media/video poster.3dfd5b2e.png";